import { pagamentiProvider } from "./providers/pagamenti";
import {
  validateAssociaMetodiPagamentoRequest,
  validateMetodiPagamentiRequest,
} from "./schemas/pagamentiSchemas";

const pagamenti = {
  metodiPagamenti: async (idVendor, token) => {
    const payload = validateMetodiPagamentiRequest({ idVendor, token });
    return pagamentiProvider.metodiPagamenti(payload.idVendor, payload.token);
  },

  associaMetodiPagamentoUtente: async (idVendor, listaMetodiPagamentoDaAssociare, token) => {
    const payload = validateAssociaMetodiPagamentoRequest({
      idVendor,
      listaMetodiPagamentoDaAssociare,
      token,
    });

    const associazioni = payload.listaMetodiPagamentoDaAssociare
      .filter((r) => r.associa)
      .map((r) => ({
        metodoPagamentoId: r.idMetodoPagamento,
      }));

    return pagamentiProvider.associaMetodiPagamentoUtente(
      payload.idVendor,
      associazioni,
      payload.token
    );
  },
};

export default pagamenti;